import { BrowserRouter, Routes, Route } from "react-router-dom";
import React, { useEffect } from "react";
import AOS from "aos";
import Landing from "./pages/landing/Landing";
import Landing2 from "./pages/landing2/Landing2";
import MaintenancePage from "./pages/maintenance/MaintenancePage";
import Careers from "./pages/careers/Careers";
import AboutUs from "./pages/about/AboutUs";
import AISearchPage from "./pages/aiSearch/AISearchPage";

function App() {
  useEffect(() => {
    AOS.init({
      offset: 0,
      easing: "ease",
      once: true
    });
    AOS.refresh();
  }, []);

  const isNotification = true; // This can be set based on your logic

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/new" element={<Landing2 />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/narada" element={<AISearchPage />} />
        <Route path="/under-maintenance" element={<MaintenancePage isNotification={isNotification} />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
